var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{staticClass:"mt-2",attrs:{"label":_vm.label},on:{"change":_vm.beginUpdateValue},model:{value:(_vm.fileInput),callback:function ($$v) {_vm.fileInput=$$v},expression:"fileInput"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }